<template>
  <div class="custom-textarea">
    <v-textarea name="input-7-1" placeholder="Reason to reject" :value="value" :outlined="outlined" :disabled="disabled"
      :readonly="readonly" :hide-details="hideDetails" @input="$emit('input', $event)"></v-textarea>
    <div v-if="rejectedBy" class="email-display"><b>Rejected By:</b> {{ rejectEmail }}</div>
  </div>
</template>
<script>
export default {
  name: 'rejectReason',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: String,
      default: null
    },
    outlined: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    rejectEmail: {
      type: String,
      default: ''
    },
    rejectedBy: {
      type: Boolean,
      default: true
    },
    hideDetails: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style scoped>
.custom-textarea {
  position: relative;
}

.email-display {
  position: absolute;
  bottom: 8px;
  right: 0;
  color: #757575;
  /* or any color you prefer */
}
</style>
